import React from 'react';
import './RunTests.css';
import { isEmpty } from '../../Utils/helpers';
import { Badge } from 'primereact/badge';

function SelectedData({ data }) {
  return (
    <>
      <div className='control-section urls-section'>
        <Badge value={`Selected URLs (${data.length})`} severity='secondary' />
      </div>

      {isEmpty(data) ? (
        <div className='no-selected-urls'>No URLs selected.</div>
      ) : (
        <ul
          data-test='selectedUrlsList'
          className='selected-urls-list'
          style={{ height: '400px', overflow: 'auto' }}
        >
          {data.map((url) => (
            <li key={url}>
              <a
                className='selectedUrl'
                href={url}
                target='_blank'
                rel='noopener noreferrer'
              >
                {url}
                {/* TODO: it used to be selectedLabel */}
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
export default SelectedData;
